/* eslint-disable @typescript-eslint/no-explicit-any */
import { Spin } from 'antd';
import React, { Suspense, useMemo } from 'react';
import routesWithPermissions from '../../routes/routesWithPermissions';
import { useRoleGetter } from '../../helpers/getUserInfo';
import NotFound from '../../pages/not-found';

interface CostumLoadableProps {
  loader: any;
  path: string;
}

const lazyComponents = new WeakMap<object, React.LazyExoticComponent<any>>();

const getLazyComponent = (loader: any) => {
  let component = lazyComponents.get(loader);

  if (!component) {
    component = React.lazy(loader);
    lazyComponents.set(loader, component);
  }

  return component;
};

export default function CustomLoadable({ loader, path }: CostumLoadableProps) {
  const LazyComponent = getLazyComponent(loader);

  const role = useRoleGetter();
  const routePermissions = routesWithPermissions[path];

  const isChildren = useMemo(
    () => (role && routePermissions.includes(role)) || !routePermissions.length,
    [role, routePermissions],
  );

  return (
    <Suspense
      fallback={
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100vw',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(30, 34, 40, 0.4)',
          }}
        >
          <div className="loader" key={0}>
            <Spin />
          </div>
        </div>
      }
    >
      {isChildren ? <LazyComponent /> : <NotFound />}
    </Suspense>
  );
}
